import { currencySymbol } from "../../assets/CurrencySymbols";

export function GetCurrentSymbol(value){
    let symbol = currencySymbol.find(item=>item.name?.toLowerCase() == value.toLowerCase() ||item?.label?.toLowerCase() == value.toLowerCase())
    return symbol.value;
}